

























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { UserPermission } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerCardProviderSettingsStore } from "@/admin/store/partnerCardProviderSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { Console } from "console";

@Component({
  components: {
  }
})
export default class CardProviderSettings extends Vue {
  featureFlagStore = useFeatureFlagStore();
  notifierStore = useNotifierStore();
  partnerCardProviderSettingsStore = usePartnerCardProviderSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() partnerId: string;

  get partnerIdAsNumber (): number {
    return parseInt(this.partnerId);
  }

  get isLoading (): boolean {
    return this.partnerCardProviderSettingsStore.isLoading;
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalCardSettingsEdit);
  }

  hasIndependentCardManagement = false;
  isSubmitting = false;
  submitDisabled = false;

  mounted () {
    this.partnerCardProviderSettingsStore.loadPartnerCardProviderSettings(this.partnerIdAsNumber)
      .then(() => {
        this.hasIndependentCardManagement = this.partnerCardProviderSettingsStore.hasIndependentCardManagement;
      });
  }

  submit () {
    if (this.submitDisabled) return;

    this.submitDisabled = true;
    this.isSubmitting = true;
    this.partnerCardProviderSettingsStore.setPartnerCardProviderSettings({
      partnerId: this.partnerIdAsNumber,
      hasIndependentCardManagement: this.hasIndependentCardManagement
    })
    .then(() => {
      this.$nextTick(() => this.notifierStore.setSuccess("Partner settings saved"));
    })
    .finally(() => {
      this.submitDisabled = false;
      this.isSubmitting = false;
    });
  }

}
